import React, { Component, PropTypes } from 'react';
import { TextField } from 'material-ui';
import { tourDurationOptions, roomCountOptions, roomSizeOptions } from '../../../utils/select-fields';
import Select from 'react-select';
import { head, T, always, equals, cond, either, compose, or, map, split, join, toUpper, concat } from 'ramda';

class InputAndSingleSelectModal extends Component {

  _updateSingleSelect = (subField, type, { value }) => {
    const valueForUpdate = cond([
      [either(equals('roomCountInfo'), equals('roomSizeInfo')), always(value.toLowerCase())],
      [T, always(value)],
    ]);
    this.props._updateSubField(subField, valueForUpdate(type));
  };

  render() {
    const { value, type, _updateSubField, _validateFieldForTextArea } = this.props;
    const fieldValue = value.value;
    const getSingleSelectValues = cond([
      [equals('tourDuration'), always(tourDurationOptions)],
      [equals('roomCountInfo'), always(roomCountOptions)],
      [equals('roomSizeInfo'), always(roomSizeOptions)],
      [T, always([])],
    ]);
    const singleSelectValues = getSingleSelectValues(type);
    const cap = str => concat(toUpper(str.charAt(0)), str.substr(1));
    const capitalize = compose(join(' '), map(cap), split(' '));
    const getInitialValue = compose(capitalize, or(value.unit), head);
    return (
      <div>
        <div className="form-line" style={{ display: 'flex' }}>
          <div className="form-line-two">
            <TextField
              style={{ width: '100%' }}
              value={String(fieldValue)}
              onChange={({ target: { value: input } }) => _updateSubField('value', input)}
              errorText={_validateFieldForTextArea(String(fieldValue), this.props.type)}
            />
          </div>
          <div className="form-line-two">
            <Select
              name="companyTypes"
              wrapperStyle={{ position: 'absolute', width: '94%' }}
              onChange={this._updateSingleSelect.bind(this, 'unit', this.props.type)}
              options={singleSelectValues}
              value={getInitialValue(singleSelectValues)}
              clearable={false}
            />
          </div>
        </div>
      </div>
    );
  }
}

InputAndSingleSelectModal.propTypes = {
  _updateSubField: PropTypes.func,
  value: PropTypes.object,
  type: PropTypes.string,
  _validateFieldForTextArea: PropTypes.func,
};

export default InputAndSingleSelectModal;



// WEBPACK FOOTER //
// ./src/app/components/profile/edit-modal/input-and-single-select-modal.jsx